/* ===== Custom Header & Announcement Bar Fix Logic ===== */
const initHeaderPositionFix = () => {
  const announcementBar = document.querySelector('#shopify-section-announcement-bar');
  const header = document.querySelector('#shopify-section-header');

  if (!header) return;

  const updateHeaderPosition = () => {
    let announcementHeight = 0;
    // Check if the announcement bar exists and is visible
    if (announcementBar && getComputedStyle(announcementBar).display !== 'none') {
      announcementHeight = announcementBar.offsetHeight;
    }
    // Set the height as a CSS variable on the root element
    document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
  };

  // Run the function on initial page load
  updateHeaderPosition();

  // Re-run the function if the window is resized
  window.addEventListener('resize', updateHeaderPosition);

  // Re-run if the announcement bar's content or style changes
  if (announcementBar) {
    const observer = new MutationObserver(updateHeaderPosition);
    observer.observe(announcementBar, { attributes: true, childList: true, subtree: true });
  }
};

// Wait for the page to fully load before running the script
document.addEventListener('DOMContentLoaded', initHeaderPositionFix);